import MoodSelectorPage from './moodSelectorPage';

export default MoodSelectorPage;
